"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontFamilies = void 0;
const types_1 = require("./types.cjs");
exports.fontFamilies = {
    default: 'CentraNo1',
    accent: 'MMSans',
    hero: 'MMPoly',
};
//# sourceMappingURL=fontFamilies.cjs.map